import React, { useMemo } from 'react';
import { MDText } from 'i18n-react';

import VrmModal from 'Components/pages/VehicleDetailsRedesign/Components/VrmModal/VrmModal';
import ListTable from 'Components/shared/ProTable/ListTable/ListTable';
import { getTableSource, mapFieldsToListTableValues } from 'Components/shared/ProTable/ListTable/ListTable.helpers';
import type { Vehicle } from 'Types/vehicle';
import { formatVehicleName } from 'Utilities/formatters';
import useVehicleHistoryChecks from 'Utilities/hooks/vehicle/useVehicleHistoryChecks';

import HistoryCheckIcon from '../HistoryCheckIcon/HistoryCheckIcon';

import LocalTexts from './HistoryCheckModal.texts';

import styles from './HistoryCheckModal.module.scss';

const LocalT = new MDText(LocalTexts);

interface HistoryCheckModalProps {
	historyChecks: Vehicle['historyChecks'];
	make: Vehicle['spec']['make'];
	model: Vehicle['spec']['model'];
	onDismissModal?: () => void;
	prettyVrm: string;
}

const HistoryCheckModal: React.FC<HistoryCheckModalProps> = ({
	historyChecks,
	make,
	model,
	onDismissModal,
	prettyVrm,
}) => {
	const { completedOnDate, list } = useVehicleHistoryChecks(historyChecks);

	const makeModel = formatVehicleName({ make, model });

	const tableValues = useMemo(() => {
		const fields = list.map((item) => ({
			key: item?.key || '',
			label: <HistoryCheckIcon isWarning={item.isWarning} />,
			value: item?.key,
		}));
		const source = getTableSource({ data: list, key: 'key', value: 'text' });

		return mapFieldsToListTableValues({
			fields,
			source,
		});
	}, [list]);

	return (
		<VrmModal
			footer={
				<div className="footer">
					<p className={styles.completedOn}>{LocalT.translate('completedOn', { date: completedOnDate })}</p>
					<p className={styles.disclaimer}>{LocalT.translate('disclaimer')}</p>
				</div>
			}
			makeModel={makeModel}
			onDismissModal={onDismissModal}
			subtitle={LocalT.translate('source')}
			title={LocalT.translate('title')}
			vrm={prettyVrm}
		>
			<ListTable
				omitNils
				className={styles.table}
				labelClassName={styles.labelColumn}
				valueClassName={styles.valueColumn}
				// @ts-ignore
				values={tableValues}
			/>
		</VrmModal>
	);
};

export default HistoryCheckModal;
